<template>
  <Teleport to="body">
    <Transition name="aira-blackout">
      <div v-if="isBlackout" class="aira-blackout" role="dialog" aria-modal="true">
        <p class="aira-blackout__title">GAME OVER</p>
        <button class="aira-blackout__button" type="button" @click="restart">
          {{ t('aira_hero.start_again') }}
        </button>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";
import { useAiraWidget } from "../store/useAiraWidgetStore";

const { t } = useI18n();
const store = useAiraWidget();
const { isBlackout } = storeToRefs(store);

/** Full reload: the run is over, so the page starts from a clean slate. */
function restart() {
  store.hideBlackout();
  window.location.reload();
}
</script>

<style scoped>
.aira-blackout {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  gap: 28px;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #000;
  color: #fff;
  text-align: center;
}

.aira-blackout__title {
  margin: 0;
  font-size: clamp(40px, 9vw, 104px);
  font-weight: 700;
  letter-spacing: 0.08em;
}

.aira-blackout__button {
  padding: 12px 24px;
  border: 1px solid #fff;
  border-radius: 999px;
  background: transparent;
  color: #fff;
  font: inherit;
  font-size: 15px;
  letter-spacing: 0.04em;
  cursor: pointer;
  transition: background 160ms ease, color 160ms ease;
}

.aira-blackout__button:hover {
  background: #fff;
  color: #000;
}

/* The screen gives out after she fills it — a slow fade reads as a blackout. */
.aira-blackout-enter-active {
  transition: opacity 420ms ease;
}

.aira-blackout-leave-active {
  transition: opacity 200ms ease;
}

.aira-blackout-enter-from,
.aira-blackout-leave-to {
  opacity: 0;
}
</style>
